export default __webpack_public_path__ + "static/media/woman-team-2.9834d4f6.avif";